import React, { useState, useRef, useEffect } from 'react';
import { Send } from 'lucide-react';

interface Props {
    onSend: (content: string) => void;
    disabled?: boolean;
    placeholder?: string;
}

export default function MessageInput({ onSend, disabled, placeholder }: Props) {
    const [content, setContent] = useState('');
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
        }
    }, [content]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (content.trim() && !disabled) {
            onSend(content.trim());
            setContent('');
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="relative flex items-end gap-3 p-4 bg-white dark:bg-navy-900 border-t border-navy-200 dark:border-navy-700">
            <textarea
                ref={textareaRef}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={placeholder || "Digite sua mensagem..."}
                disabled={disabled}
                className="w-full resize-none max-h-32 p-4 rounded-xl border border-navy-200 dark:border-navy-600 focus:ring-2 focus:ring-accent-400/50 focus:border-accent-400 bg-navy-50 dark:bg-navy-800 text-navy-900 dark:text-navy-100 placeholder-navy-400 dark:placeholder-navy-500 transition-all duration-200"
                rows={1}
            />
            <button
                type="submit"
                disabled={!content.trim() || disabled}
                className="p-4 rounded-xl btn-accent disabled:bg-navy-300 disabled:text-navy-500 dark:disabled:bg-navy-700 disabled:cursor-not-allowed disabled:shadow-none transition-all duration-200"
            >
                <Send className="w-5 h-5" />
            </button>
        </form>
    );
}
